import * as apiConst from "./apiConst";

export const getIndustryQoutes = () => {
  var Mheaders = new Headers({
    "X-Currency": "USD",
    "X-Language": "FA",
  });
  return fetch(`${apiConst.originUrl}${apiConst.tickersQuotes}`, {
    method: "GET",
    headers: Mheaders,
  })
    .then((response) => response.json())
    .catch((e) => {
      console.log("Error : ", e);
    });
};

export const getFinancialStats = () => {
  var Mheaders = new Headers({
    "X-Currency": "USD",
    "X-Language": "FA",
  });
  return fetch(`${apiConst.originUrl}${apiConst.tickers}`, {
    method: "GET",
    headers: Mheaders,
  })
    .then((response) => response.json())
    .catch((e) => {
      console.log("Error : ", e);
    });
};

export const getPlans = (lang) => {
  return fetch(`${apiConst.originUrl}${apiConst.plans}`, {
    method: 'GET',
    headers: {
        'x-language': lang
    }
  })
    .then((response) => response.json())
    .catch((e) => {
      console.log("Error : ", e);
    });
};
